import axios from "axios";
import { useAuthStore } from "../store/auth.store";
import { serviceKeys } from "../constants";

const api = axios.create({
  baseURL: serviceKeys.BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken;

  if (token !== undefined && token !== null) {
   config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
